import { LanguageNameSpaces, WorkspaceType } from "@shared/types";
import { TranslationKeys } from "@shared/common/i18n/types";

const USER_ENDPOINTS = [
  "login",
  "get_captcha",
  "validate_captcha",
  "refresh_token",
  "oauth_user",
  "logout",
  "register",
  "get_basic_details_from_uuid",
  "verify_confirm_email_code",
  "verify_confirm_email_code_by_uuid",
  "resend_registration_email",
  "connect_to_telegram",
  "get_uuid_deeplink",
  "verify_personal_details",
  "send_connect_to_telegram_auth_code",
  "send_connect_to_telegram_auth_code_from_uuid",
  "finish_onboarding",
  "reset_password_inapp",
  "change_password",
  "forgot_password",
  "check_password",
  "generate_qr_code",
  "store_two_factor_auth",
  "disable_two_factor_auth",
  "check_referral",
  "referral_clicked",
  "delete_cornix_account_confirmation_email",
  "check_version",
  "check_uuid",
  "get_login_auth_url",
  "validate_web_app_init_data",
  "get_web_app_init_data",
  "get_all_plan_details",
  "get_all_payment_methods",
  "get_payment_link",
  "get_payment_status",
  "get_recent_payments",
  "get_current_discount",
  "get_cancellation_reasons",
  "save_cancellation_reason",
  "get_cancel_subscription_promo_code",
  "cancel_subscription",
  "get_billing_agreement_details",
  "get_new_payment_price",
  "approve_payment",
  "get_marketplace_info",
  "get_groups_data",
  "get_group_overview",
  "get_group_reviews",
  "get_user_group_data",
  "get_signal_extra_info_general",
  "get_exchange_signal_extra_info_activities",
  "get_exchange_signal_extra_info_targets",
  "get_signal_extra_info_configuration",
  "get_most_fulfilled_exchange_signal",
  "get_exchange_signal_ids",
  "get_dashboard_data",
  "get_exchange_channels_information",
  "get_auth_url",
  "accept_affiliation_terms",
  "get_or_create_promo_code",
  "get_or_create_referral_link",
  "create_referral_link",
  "edit_referral_link",
  "delete_referral_link",
  "get_referral_links",
  "get_commission_history",
  "get_payouts_history",
  "get_referral_history",
  "get_withdrawable_funds",
  "create_paypal_payout_method",
  "edit_paypal_payout_method",
  "create_payout",
  "cancel_payout",
  "referral_clicked",
  "get_payout_methods",
  "get_referred_chart",
  "get_earnings_chart",
  "create_access_token",
  "check_account_status",
  "create_api_keys",
  "store_nps_result",
  "get_personal_details",
  "set_personal_details",
  "disconnect_telegram_account_confirmation_email",
  "disconnect_discord_account_confirmation_email",
  "contact_us_on_tg",
  "createAccountFromInvite",
  "getAccountInvite",
  "getAccountInvites",
  "deleteAccountInvite",
  "createAccountInvite",
  "connect_email",
  "confirm_email_connection",
  "approve_subscription",
  "create_personal_sub_group",
  "edit_personal_sub_group",
  "delete_personal_sub_group",
  "create_sub_group",
  "edit_sub_group",
  "delete_sub_group",
  "get_account_invite",
  "get_account_invites",
  "create_account_invite",
  "create_account_from_invite",
  "delete_account_invite",
  "finalize_account_invite",
  "symbols",
  "get_available_icon_assets",
  "get_exchanges_metadata",
  "get_precisions",
  "get_asset_manager_configuration",
  "set_asset_manager_configuration",
  "generate_asset_manager_invoice",
  "get_asset_manager_invoices",
  "update_asset_manager_invoice_status",
  "update_asset_manager_invoice_visibility",
  "get_whitelabel_configuration",
];

export const USER_WORKSPACE_ENDPOINTS = new Set(
  USER_ENDPOINTS.concat(
    USER_ENDPOINTS.map((endpoint) => endpoint + "/")
  ).concat(USER_ENDPOINTS.map((endpoint) => "/" + endpoint + "/"))
);

export const WORKSPACE_TO_DISPLAY_NAME: {
  [key in WorkspaceType]?: TranslationKeys<LanguageNameSpaces.COMMON>;
} = {
  [WorkspaceType.ADMIN]: "workspace.admin",
  [WorkspaceType.USER]: "workspace.user",
};
